export const configuration = {
  production: process.env.NODE_ENV === 'production',
  landingUrl: 'https://officely.ai',
  homePage: '/dashboard',
  //api_url:'https://api-dev.officely.ai'
  api_url:'https://api.officely.ai'
  //api_url:'http://127.0.0.1:5000'
};
